exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe.xcomponent-component-frame {\n  z-index: auto !important;\n}\n", ""]);

// exports
